<template>
    <v-card>
        <v-layout>
            <v-flex xs12>
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Stores</h1>
                    </v-flex>
                </v-layout>
                <v-layout wrap>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Filter Stores"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-checkbox
                            label="Active Only"
                            v-model="activeOnly"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm2 offset-sm1>
                        <v-btn
                            color="success"
                            block
                            @click="editStore({ Active: true })"
                        >
                            Add
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                        <v-data-table
                            :headers="headers"
                            :items="stores"
                            :loading="loading"
                            :search="search"
                            hide-actions
                            must-sort
                        >
                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <tr :data-id="props.item.ID">
                                    <td>{{props.item.Name}}</td>
                                    <td>{{props.item.Address}}</td>
                                    <td>{{formatPhoneNumber(props.item.PhoneNumber)}}</td>
                                    <td>{{props.item.StoreContact}}</td>
                                    <td>{{formatPhoneNumber(props.item.StoreContactNumber)}}</td>
                                    <td>{{props.item.ProduceOrdererEmail}}</td>
                                    <td v-if="props.item.Active"><v-icon color="success">check</v-icon></td>
                                    <td v-if="!props.item.Active"><v-icon color="error">close</v-icon></td>
                                    <td>
                                        <v-btn
                                            color="warning"
                                            block
                                            @click="editStore(props.item)"
                                        >
                                            Edit
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                            <template v-if="!loading" slot="no-data">
                                <v-alert v-if="loadError" outline :value="true" color="error" icon="error">
                                    {{loadError}}
                                </v-alert>
                                <v-alert v-if="!loadError" outline :value="true" type="info">
                                    No results found
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-dialog v-model="showEditDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark :disabled="saving" @click="cancelEditStore">
                            <v-icon large>close</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-title v-if="editedStore && editedStore.ID">Edit Store</v-toolbar-title>
                        <v-toolbar-title v-else>Add New Store</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-form ref="editForm" v-model="editStoreValid">
                        <v-layout class="dialog-content">
                            <v-flex xs12 md6 offset-md3>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable
                                            counter="100"
                                            maxlength="100"
                                            v-model="editedStore.Name"
                                            :rules="[rules.required]"
                                            label="Store Name">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable
                                            counter="100"
                                            maxlength="100"
                                            v-model="editedStore.Address"
                                            :rules="[rules.required]"
                                            label="Store Address">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable 
                                            :rules="[rules.required, rules.phoneNumber]"
                                            :mask="phoneMask(editedStore.PhoneNumber)"
                                            v-model="editedStore.PhoneNumber" 
                                            label="Store Phone Number">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable 
                                            :rules="[rules.faxNumber]"
                                            :mask="phoneMask(editedStore.FaxNumber)"
                                            v-model="editedStore.FaxNumber" 
                                            label="Store Fax Number">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable 
                                            counter="100" 
                                            maxlength="100"
                                            :rules="[rules.required]"
                                            v-model="editedStore.StoreContact" 
                                            label="Store Contact Person">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable 
                                            :rules="[rules.required, rules.phoneNumber]"
                                            :mask="phoneMask(editedStore.StoreContactNumber)"
                                            v-model="editedStore.StoreContactNumber" 
                                            label="Store Contact Number">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable 
                                            counter="100" 
                                            maxlength="100"
                                            :rules="[rules.required, rules.email]"
                                            v-model="editedStore.ProduceOrdererEmail" 
                                            label="Produce Orderer Email">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable 
                                            counter="200" 
                                            maxlength="200"
                                            :rules="[rules.required, rules.email]"
                                            v-model="editedStore.PackagingOrderEmail" 
                                            label="Packaging Orderer Email">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-layout>
                                            <v-flex xs8>
                                                <v-text-field
                                                    label="Store Logo"
                                                    @click="pickLogo"
                                                    v-model="logoFileName"
                                                ></v-text-field>
                                                <input
                                                    type="file"
                                                    style="display: none"
                                                    ref="image"
                                                    accept="image/*"
                                                    @change="onLogoPicked"
                                                >
                                            </v-flex>
                                            <v-flex xs4>
                                                <v-btn block color="accent" :disabled="saving" @click="pickLogo">Choose Logo</v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-checkbox label="Active" v-model="editedStore.Active"></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-select
                                            :items="departments"
                                            item-text="Name"
                                            item-value="ID"
                                            v-model="editedStore.DepartmentIDs"
                                            label="Departments"
                                            multiple
                                            chips
                                            hint="Departments"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout wrap class="dialog-action-buttons">
                                    <v-flex xs12 sm6>
                                        <v-btn block color="error" :disabled="saving" @click="cancelEditStore">Cancel</v-btn>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-btn block color="success" :disabled="!editStoreValid" :loading="saving" @click="saveEditedStore">Save</v-btn>
                                    </v-flex>
                                    <v-flex xs12>
                                        <error-alert :content="saveError" :display="saveError"></error-alert>
                                    </v-flex>
                                </v-layout>                            
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-card>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import formatters from "../../helpers/formatters";
import ErrorAlert from "../common/ErrorAlert"
import util from '@/services/util';

export default {
    components: {
        ErrorAlert
    },
    props: [
        
    ],
    data() {
        return {
            logoFileName: "",
            editedStore: {},
            showEditDialog: false,
            editStoreValid: false,
            search: "",
            activeOnly: true,
            rules: validationRules.rules,
            headers: [
                {
                    text: "Name",
                    value: "Name"
                },
                {
                    text: "Address",
                    value: "Address"
                },
                {
                    text: "Phone",
                    value: "PhoneNumber"
                },
                {
                    text: "Contact",
                    value: "StoreContact"
                },
                {
                    text: "Contact Phone",
                    value: "StoreContactNumber"
                },
                {
                    text: "Produce Orderer",
                    value: "ProduceOrdererEmail"
                },
                {
                    text: "Active",
                    value: "Active"
                },
                {
                    text: "", // edit button
                    sortable: false
                }
            ]
        };
    },
    computed: {
        loading() {
            return this.$store.state.storeStore.loading;
        },
        loadError() {
            return this.$store.state.storeStore.loadError;
        },
        saving() {
            return this.$store.state.storeStore.saving;
        },
        saveError() {
            return this.$store.state.storeStore.saveError;
        },
        stores() {
            return this.$store.state.storeStore.stores.filter(s => s.Active || !this.activeOnly);
        },
        departments() {
            return this.$store.state.departmentStore.departments.sort(util.sortByName);
        }
    },
    methods: {
        pickLogo() {
            this.$refs.image.click();
        },
        onLogoPicked(e) {
            // file upload adapted from https://stackoverflow.com/questions/44989162/file-upload-in-vuetify
            const files = e.target.files;
            
			if(files[0] !== undefined) {
                this.editedStore.LogoName = files[0].name;
                this.logoFileName = this.editedStore.LogoName;
                
                if(this.editedStore.LogoName.lastIndexOf('.') <= 0) {
					return;
				}

				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
                    this.editedStore.LogoName = files[0].name;
                    this.logoFileName = this.editedStore.LogoName;

                    this.editedStore.LogoData = fr.result; // this is an image file that can be sent to server
				});
            }
            else {
                this.editedStore.LogoName = "";
                this.logoFileName = this.editedStore.LogoName;
                this.editedStore.LogoData = "";
            }
		},
        phoneMask(value) {
            return validationRules.phoneMask(value);
        },
        loadStores() {
            this.$store.dispatch("storeStore/loadStores");
        },
        editStore(item) {
            this.$store.dispatch("storeStore/clearSaveError");

            // show which fields are mandatory when opening the edit form
            this.$refs.editForm.validate();

            this.editedStore = Object.assign({}, item);

            if (this.editedStore && this.editedStore.LogoPath) {
                this.logoFileName = this.editedStore.LogoPath.slice(this.editedStore.LogoPath.lastIndexOf("/") + 1);
            }
            else {
                this.logoFileName = "";
            }
            

            // transform the DepartmentIDs property into something that the v-select can understand
            // if it was a string, it needs to be an array
            if (typeof this.editedStore.DepartmentIDs === "string") {
                // split string into separate strings, then parse these into numbers
                this.editedStore.DepartmentIDs = this.editedStore.DepartmentIDs.split(",").map(function(currentValue, index, arr) {
                    return parseInt(currentValue);
                });
            }

            this.showEditDialog = true;
        },
        cancelEditStore() {
            this.showEditDialog = false;
            this.editedStore = {};
        },
        saveEditedStore() {
            var that = this;

            this.$store.dispatch("storeStore/saveStore", {
                store: this.editedStore,
                finally: function() {
                    if (that.$store.state.storeStore.saveError) {
                        // do not close the dialog
                        // display the error
                    }
                    else {
                        // close the dialog
                        that.cancelEditStore();
                    }
                }
            });
        },
        formatPhoneNumber(value) {
            return formatters.formatPhoneNumber(value);
        }
    },
    created() {
        this.loadStores();
    }
};
</script>

<style>
    
</style>
